export default __webpack_public_path__ + "static/media/105.f4a6e6e8.jpg";